/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { QuoteWorkRate } from './';
import {
    QuoteWorkRateFromJSON,
    QuoteWorkRateFromJSONTyped,
    QuoteWorkRateToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsQuoteDetailsRequest
 */
export interface TimeAndMaterialsQuoteDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof TimeAndMaterialsQuoteDetailsRequest
     */
    projectScope?: string;
    /**
     * 
     * @type {QuoteWorkRate}
     * @memberof TimeAndMaterialsQuoteDetailsRequest
     */
    workRate?: QuoteWorkRate;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsQuoteDetailsRequest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsQuoteDetailsRequest
     */
    estimatedEndDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsQuoteDetailsRequest
     */
    estimatedTotalWorkAmount?: number;
}

/**
 * Check if a given object implements the TimeAndMaterialsQuoteDetailsRequest interface.
 */
export function instanceOfTimeAndMaterialsQuoteDetailsRequest(value: object): value is TimeAndMaterialsQuoteDetailsRequest {
    return true;
}

export function TimeAndMaterialsQuoteDetailsRequestFromJSON(json: any): TimeAndMaterialsQuoteDetailsRequest {
    return TimeAndMaterialsQuoteDetailsRequestFromJSONTyped(json, false);
}

export function TimeAndMaterialsQuoteDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsQuoteDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'projectScope': json['projectScope'] == null ? undefined : json['projectScope'],
        'workRate': json['workRate'] == null ? undefined : QuoteWorkRateFromJSON(json['workRate']),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'estimatedEndDate': json['estimatedEndDate'] == null ? undefined : (new Date(json['estimatedEndDate'])),
        'estimatedTotalWorkAmount': json['estimatedTotalWorkAmount'] == null ? undefined : json['estimatedTotalWorkAmount'],
    };
}

export function TimeAndMaterialsQuoteDetailsRequestToJSON(value?: TimeAndMaterialsQuoteDetailsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectScope': value['projectScope'],
        'workRate': QuoteWorkRateToJSON(value['workRate']),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'estimatedEndDate': value['estimatedEndDate'] == null ? undefined : ((value['estimatedEndDate']).toISOString().substring(0,10)),
        'estimatedTotalWorkAmount': value['estimatedTotalWorkAmount'],
    };
}

